<div class="subpage-container">
    <div class="container g-0 m-0">
        <div class="d-flex align-items-center ps-5 pb-3 pt-2">
            <app-event-logs-filter class="pe-2" [numberOfResults]="numberOfEvents"
                [selectedEventLogNumbers]="requestData.eventLogNumbers || []"
                (applied)="onFilterApplied($event)"></app-event-logs-filter>
            <app-sort class="pe-2" (close)="onSortOption($event)"></app-sort>
            <div class="datepicker-container-wrapper position-relative">
                <div class="button-wrapper">
                    <div class="button">
                        <img alt="Date" src="assets/core/table-button/date.svg" />
                        <div class="button-text" (click)="toggleDatepicker()"
                            [ngClass]="{ changed: startDate && endDate }">
                            <ng-container *ngIf="startDate && endDate; else noDateSelected">
                                {{ selectedDate }}
                            </ng-container>
                            <ng-template #noDateSelected>
                                <span class="nonselected-date">{{ "SELECTDATE" | translate }}</span>
                            </ng-template>
                        </div>
                        <img *ngIf="startDate && endDate" alt="Exit" src="assets/device/x.svg"
                            (click)="clearDates()" />
                    </div>
                </div>
                @if (isDatepickerOpen) {
                <div class="overlay" (click)="toggleDatepicker()"></div>
                <app-datepicker [scale]="1.1" [range]="true" (dateRangeChanged)="onDateRangeChanged($event)"
                    [inputFromDate]="startDate" [inputToDate]="endDate"></app-datepicker>
                }
            </div>
            <app-search class="ps-2" placeholder="{{ 'SETTINGS_SEARCHBYNAME&CODE' | translate }}"
                (searchChange)="searchChange($event)"></app-search>
            @if (authService.isAuthorized([PermissionsEnum.Ondemand_event_log_download, PermissionsEnum.Scheduled_event_log_download])) {
            <div class="download-button ms-auto me-5 ps-3 pe-3 pb-2 pt-1" (click)="download()">
                <svg-icon alt="Download" class="hover-effect" src="assets/core/table/download.svg"></svg-icon>
            </div>
            }
        </div>
        <div class="row g-0 m-0">
            <table class="wide-table">
                <thead>
                    <tr>
                        <th></th>
                        <th><span>{{ "EVENT_NAME" | translate }}</span></th>
                        <th><span>{{ "EVENT_TYPE" | translate }}</span></th>
                        <th><span>{{ "DESCRIPTION" | translate }}</span></th>
                        <th><span>{{ "EVENT_CODE" | translate }}</span></th>
                        <th><span>{{ "METER_TIME" | translate }}</span></th>
                        <th><span>{{ "INGESTIONTIME" | translate }}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of events">
                        <td appIsNew [executedTime]="row.ingestionTime!"></td>
                        <td><span>{{ row.eventName || '/' }}</span></td>
                        <td>
                            <span class="label-box" [ngStyle]="{ 'background-color': eventLogColor(row.eventLogNumber) }">
                                {{ eventLogLabelKey(row.eventLogNumber) | translate }}
                            </span>
                        </td>
                        <td><span>{{ row.description || '/' }}</span></td>
                        <td><span>{{ row.eventCode }}</span></td>
                        <td><span>{{ row.eventTime | date: 'dd MMMM yyyy hh:mm a' }}</span></td>
                        <td><span>{{ row.ingestionTime | date: 'dd MMMM yyyy hh:mm a' }}</span></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="container-down">
        <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfEvents"
            [pageSize]="pageSize" [currentPage]="currentPage"
            (pageChange)="pageChange($event)"></app-pagination>
    </div>
</div>
